import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table,Modal } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const PaymentList = () => {
  const [loading, setLoading] = useState(false);
  const today = new Date().toISOString().split("T")[0]; // "2026-03-13"
  const formattedToday = new Date(today)
  .toLocaleDateString("en-GB")
  .replace(/\//g, "-");
  const [filters, setFilters] = useState({
    vendor_type_id: "",
    vendor_id: "",
  });


    const navigate = useNavigate();
const [selectedVendor, setSelectedVendor] = useState(null);
  const [payments, setPayments] = useState([]);
  const [vendorTypes, setVendorTypes] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedMember, setSelectedMember] = useState(null);
  const [showPayModal, setShowPayModal] = useState(false);
    const [payVendorId, setPayVendorId] = useState(null);
    const [payAmount, setPayAmount] = useState("");
    const [remarks, setRemarks] = useState("");
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [selectAllMembers, setSelectAllMembers] = useState(true);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAllJobs, setSelectAllJobs] = useState(false);
  const [jobList, setJobList] = useState([]);

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

const handleSelectAllMembers = (checked) => {
  setSelectAllMembers(checked);

  if (checked) {
    setSelectedMembers(memberList.map((m) => m.user_id));
  } else {
    setSelectedMembers([]);
  }
};


const fetchJobWiseAmount = async (vendorId, row) => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/payment/getJobWiseBalance`,
      { vendor_id: vendorId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const jobs = res.data?.data || [];

    // ❌ IF EMPTY → SHOW API MESSAGE
    if (!jobs || jobs.length === 0) {
      Swal.fire(
        "Alert",
        "No jobs available",
        "warning"
      );
      return;
    }

    // ✅ IF DATA EXISTS → OPEN MODAL
    setSelectedVendor(row);
    setPayVendorId(vendorId);
    setPayAmount("");
    setRemarks("");
    setSelectedJobs([]);
    setSelectAllJobs(false);
    setSelectAllMembers(false);

    setJobList(jobs);

    if (row.vendor_type_id === 3) {
      fetchMembers(vendorId);
    } else {
      setMemberList([]);
    }

    setShowPayModal(true);

  } catch (err) {
    if (handle401(err)) return;

    Swal.fire(
      "Error",
      err?.response?.data?.message || "Something went wrong",
      "error"
    );
  }
};

const handleMemberSelect = (memberId) => {
  let updated = [];

  if (selectedMembers.includes(memberId)) {
    updated = selectedMembers.filter((id) => id !== memberId);
  } else {
    updated = [...selectedMembers, memberId];
  }

  setSelectedMembers(updated);
  setSelectAllMembers(updated.length === memberList.length);
};

 /* ---------------- FETCH DROPDOWNS ---------------- */


  const fetchMembers = async (shgId) => {
     try {
       if (!shgId) {
         setMemberList([]);
         return;
       }

   const token = localStorage.getItem("token");

       const res = await axios.post(
         `${BASE_URL}/memberList`,
         {
           shg_id: shgId, // ✅ THIS WAS MISSING
         },
         {
           headers: { Authorization: `Bearer ${token}` },
         },
       );

       setMemberList(res.data?.data || []);
     } catch (error) {
       if (handle401(error)) return;

       console.error("Member fetch error", error);
       setMemberList([]);
     }
   };



const handlePaymentSubmit = async () => {
  if (!payAmount) {
    Swal.fire("Alert", "Amount is required", "error");
    return;
  }

  if (selectedVendor?.vendor_type_id === 3 && selectedMembers.length === 0) {
    Swal.fire("Alert", "Please select at least one member", "error");
    return;
  }

  try {
    const token = localStorage.getItem("token");

    // ✅ Extract action_master_ids
    const action_master_ids = selectedJobs.map(
      (j) => j.action_master_id
    );

    // ✅ Extract amounts (IMPORTANT)
    const amounts = selectedJobs.map(
      (j) => Number(j.amount || 0)
    );

    // ✅ Total Amount
    const total_amount =
      selectedJobs.length > 0
        ? amounts.reduce((sum, a) => sum + a, 0)
        : Number(payAmount);

    const roundedTotal = Number(total_amount.toFixed(2));

    const payload = {
      vendor_id: payVendorId,
      action_master_ids: action_master_ids,
      amounts: amounts,
      total_amount: roundedTotal,
      members: selectedMembers,
      remarks: remarks,
    };

    console.log("FINAL PAYLOAD 👉", payload);

    const res = await axios.post(
      `${BASE_URL}/payment/doPayment`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    Swal.fire("Success", res.data.message, "success");

    setShowPayModal(false);
    fetchPayments(page);

  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Alert",
      error?.response?.data?.message || "Something went wrong",
      "error"
    );
  }
};

const fetchVendorTypes = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorTypesList`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setVendorTypes(res.data.data || []);
  } catch (error) {
    if (handle401(error)) return;
    console.error("Fetch vendor types error", error);
  }
};

const handleJobSelect = (job) => {
  setSelectedJobs((prev) =>
    prev.some((j) => j.action_master_id === job.action_master_id)
      ? prev.filter((j) => j.action_master_id !== job.action_master_id)
      : [...prev, job]
  );
};

  const handleSelectAllJobs = (checked) => {
  if (checked) {
    setSelectedJobs([...jobList]);
  } else {
    setSelectedJobs([]);
  }
};

const fetchVendors = async (vendorTypeId) => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      { vendor_type_id: vendorTypeId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setVendors(res.data.data || []);
  } catch (error) {
    if (handle401(error)) return;
    console.error("Fetch vendors error", error);
  }
};

/* ---------------- FETCH PAYMENT LIST ---------------- */

const fetchPayments = async (pageNo = 1, filterValues = filters, perPageValue = perPage) => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    const payload = {
  vendor_type_id: filterValues.vendor_type_id || "",
  vendor_id: filterValues.vendor_id || "",
  page: pageNo,
  per_page: perPageValue,
};

    const res = await axios.post(
      `${BASE_URL}/payment/paymentsList`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setPayments(res.data.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
  Math.ceil((res.data.total_records || 0) / (res.data.per_page || perPageValue))
);

  } catch (error) {
    if (handle401(error)) return;
    console.error("Payment List Error", error);
  } finally {
    setLoading(false);
  }
};


const handleExportExcel = async () => {
  try {
    const token = localStorage.getItem("token");

    const payload = {
      vendor_type_id: filters.vendor_type_id || "",
      vendor_id: filters.vendor_id || "",
      page: 1,
      per_page: totalRecords > 100 ? 100 : totalRecords || 10,
    };

    const res = await axios.post(
      `${BASE_URL}/payment/paymentsList`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const exportData = res.data?.data || [];

    if (!exportData.length) {
      Swal.fire("No Data", "Nothing to export", "warning");
      return;
    }

    const formattedData = exportData.map((r, index) => ({
      "SL No": index + 1,
      "Organization Name": `${r.vendors_master_name} (${r.vendor_type_short_name})`,
      "Total Earnings (₹)": r.total_amount,
      "Amount Paid (₹)": r.total_paid,
      "Outstanding Balance (₹)": r.total_balance,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Payment Transaction List"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(file, `Payment_Transaction_List_${formattedToday}.xlsx`);

  } catch (error) {
    console.log("Export Error:", error);
    if (handle401(error)) return;

    Swal.fire(
      "Error",
      error?.response?.data?.message || "Failed to export data",
      "error"
    );
  }
};

const handleViewDetails = (vendorId) => {
  console.log("Vendor ID clicked:", vendorId);
  navigate(`/app/payment-details/${vendorId}`);
};

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};

useEffect(() => {
  if (jobList.length > 0 && selectedJobs.length === jobList.length) {
    setSelectAllJobs(true);
  } else {
    setSelectAllJobs(false);
  }
}, [selectedJobs, jobList]);

  /* ---------------- PAGINATION NUMBERS ---------------- */

  const getPageNumbers = () => {
    const pages = [];
    const max = 5;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);

    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  /* ---------------- EFFECTS ---------------- */

  useEffect(() => {
    fetchVendorTypes();
    fetchPayments(1);
  }, []);

  useEffect(() => {  if (selectedJobs.length > 0) {
    const total = selectedJobs.reduce(
      (sum, j) => sum + Number(j.amount || 0),
      0
    );

    const rounded = Number(total.toFixed(2));

    setPayAmount(rounded); // auto-fill
  }
}, [selectedJobs]);

  useEffect(() => {
  if (memberList.length > 0) {
    setSelectedMembers(memberList.map((m) => m.user_id));
    setSelectAllMembers(true);
  }
}, [memberList]);

  useEffect(() => {
    if (filters.vendor_type_id) {
      fetchVendors(filters.vendor_type_id);
    } else {
      setVendors([]);
      setFilters({ ...filters, vendor_id: "" });
    }
  }, [filters.vendor_type_id]);

  useEffect(() => {
    fetchPayments(1);
  }, [perPage]);

  /* ---------------- UI ---------------- */

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔷 SEARCH CARD */}
      <Card className="mb-4 border-0" style={{
    background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
    borderRadius: "14px",
    boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
  }}>
        <div className="px-4 py-3 text-white" style={{ background: "linear-gradient(90deg,#0D47A1,#1565C1)" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter me-2"></i> Job Worker Payment List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            {/* Vendor Type */}

            {/* Vendor Type */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation Type</Form.Label>
    <Form.Select
      value={filters.vendor_type_id}
      onChange={(e) => {
        const vendorTypeId = e.target.value;

        setFilters({ vendor_type_id: vendorTypeId, vendor_id: "" });

        // Fetch vendors for selected type
        if (vendorTypeId) {
          fetchVendors(vendorTypeId);
        } else {
          setVendors([]);
        }


      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
    >
      <option value="">Select Organisation Type</option>
      {vendorTypes.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendor_type_name} ({v.vendor_type_short_name})
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

{/* Vendor */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation</Form.Label>
    <Form.Select
      value={filters.vendor_id}
      onChange={(e) => {
        const vendorId = e.target.value;
        setFilters({ ...filters, vendor_id: vendorId });

      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
      disabled={!filters.vendor_type_id || vendors.length === 0}
    >
      <option value="">Select Organisation</option>
      {vendors.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

{/* Record Showing */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>
    <Form.Select
      value={perPage}
      onChange={(e) => {
        const value = Number(e.target.value);
        setPerPage(value);
        setPage(1);

        // Reload table with new perPage
        fetchPayments(1);
      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
    >
      <option value={10}>10 Per Page</option>
      <option value={25}>25 Per Page</option>
      <option value={50}>50 Per Page</option>
      <option value={100}>100 Per Page</option>
    </Form.Select>
  </Form.Group>
</Col>

{/* Search & Reset Buttons */}
<Col md={3} className="d-flex gap-3 mt-3">
  <Button
    className="w-50 fw-semibold text-white"
    style={{ background: "#1565C1", border: "none", borderRadius: "10px" }}
    onClick={() => fetchPayments(1)}
  >
    <i className="fa-solid fa-magnifying-glass me-2"></i> Search
  </Button>

  <Button
  className="w-50 fw-semibold text-white"
  style={{ background: "#E53935", border: "none", borderRadius: "10px" }}
  onClick={() => {
    const resetFilters = { vendor_type_id: "", vendor_id: "" };

    setFilters(resetFilters);
    setVendors([]);
    setPage(1);
    setPerPage(10);
    fetchPayments(1, resetFilters, 10);
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

</Col>



          </Row>
        </Card.Body>
      </Card>



      <div className="d-flex align-items-center justify-content-between mb-4">

  {/* Left Button */}
  <Button
    style={{
      background: "#43A047",
      border: "none",
      borderRadius: "8px",
    }}
    className="px-4"
    onClick={handleExportExcel}
  >
    <i className="fa-solid fa-file-excel me-2"></i> Export to Excel
  </Button>

  {/* Center Title */}
  <div className="text-center flex-grow-1">
    <h4 className="fw-bold text-dark mb-1">Payment List</h4>
    <div className="fs-6 text-success">
      Payment report as on Date{" "}
      <span className="fw-bold">{formattedToday}</span>
    </div>
  </div>

  {/* Empty spacer to balance flex */}
  <div style={{ width: "160px" }}></div>

</div>

     {/* ====================== LOADER ====================== */}
{loading && (
  <div className="loader-wrapper text-center my-4">
    <div className="blue-spinner"></div>
    <p className="loading-text">Loading...</p>
  </div>
)}

{/* ====================== CARD ====================== */}
{!loading && (
  <Card className="border-0 shadow">
    {payments.length > 0 ? (
      <>
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th style={theadStyle}>Sl. No.</th>
              <th style={theadStyle}>Organization Name</th>
              <th style={theadStyle}>Total Earnings (₹)</th>
              <th style={theadStyle}>Amount Paid (₹)</th>
              <th style={theadStyle}>Outstanding Balance (₹)</th>
              <th style={theadStyle}>View Ledger</th>
              <th style={theadStyle}>Make Payment</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((row, index) => (
              <tr key={row.id}>
                <td className="text-center">
                  {(page - 1) * perPage + index + 1}
                </td>

                <td className="text-center">
                  {row.vendors_master_name} ({row.vendor_type_short_name})
                </td>

                <td className="text-center">₹ {row.total_amount}</td>
                <td className="text-center">₹ {row.total_paid}</td>
                <td className="text-center">₹ {row.total_balance}</td>

                <td className="text-center">
                  <button
                    className="btn btn-sm btn-info text-white"
                    onClick={() => handleViewDetails(row.vendor_id)}
                  >
                    <i className="fa-solid fa-eye"></i>
                  </button>
                </td>

                <td className="text-center">
                  <button

                    className="btn btn-sm btn-success text-white"
                    onClick={() => {
                    fetchJobWiseAmount(row.vendor_id, row);
                    }}
                  >
                    Pay
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* ====================== PAGINATION ====================== */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <ul className="pagination">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => fetchPayments(page - 1)}
                >
                  ‹
                </button>
              </li>

              {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p && "active"}`}>
                  <button
                    className="page-link"
                    onClick={() => fetchPayments(p)}
                  >
                    {p}
                  </button>
                </li>
              ))}

              <li className={`page-item ${page === totalPages && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => fetchPayments(page + 1)}
                >
                  ›
                </button>
              </li>
            </ul>
          </div>
        )}
      </>
    ) : (
      <div className="text-center my-4 text-muted">
        No Data Found
      </div>
    )}
  </Card>
)}

  <Modal
  show={showPayModal}
  onHide={() => setShowPayModal(false)}
  centered
  size="lg"
  backdrop="static"
>
  <Modal.Header
    closeButton
    style={{
      background: "linear-gradient(90deg,#1565C1,#1E88E5)",
      color: "white",
    }}
  >
    <Modal.Title>
      <i className="fa-solid fa-receipt me-2"></i>
      Make Payment
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedVendor && (
      <div
        style={{
          border: "1px dashed #b0c4de",
          borderRadius: "10px",
          padding: "20px",
          background: "#fbfdff",
        }}
      >
        {/* Header */}
        <div className="text-center mb-3">
          <h5 className="fw-bold text-primary mb-1">Payment Slip</h5>
          <div className="text-muted small">
            Date: {formattedToday}
          </div>
        </div>

        <hr />

        {/* Organisation */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="small text-muted">Organisation</div>
            <div className="fw-bold">
              {selectedVendor.vendors_master_name}
            </div>
          </Col>

          <Col md={6}>
            <div className="small text-muted">Type</div>
            <div className="fw-semibold">
              {selectedVendor.vendor_type_short_name}
            </div>
          </Col>
        </Row>

        {/* Summary */}
        <Row className="text-center mb-3">
          <Col>
            <div className="bg-light p-2 rounded">
              <div className="small text-muted">Total</div>
              <div className="fw-bold">
                ₹ {selectedVendor.total_amount}
              </div>
            </div>
          </Col>

          <Col>
            <div className="bg-success-subtle p-2 rounded">
              <div className="small text-muted">Paid</div>
              <div className="fw-bold text-success">
                ₹ {selectedVendor.total_paid}
              </div>
            </div>
          </Col>

          <Col>
            <div className="bg-danger-subtle p-2 rounded">
              <div className="small text-muted">Balance</div>
              <div className="fw-bold text-danger">
                ₹ {selectedVendor.total_balance}
              </div>
            </div>
          </Col>
        </Row>

        {/* ================= JOB LIST ================= */}
        {jobList?.length > 0 && (
          <>
            <h6 className="fw-bold text-primary mt-3">
              Select Jobs
            </h6>

            <div style={{ maxHeight: "none", overflowY: "visible" }}>
              <Table bordered hover size="sm">
                <thead style={{ background: "#edf7fe" }}>
                  <tr className="text-center">
                    <th>
                      <Form.Check
                        checked={selectAllJobs}
                        onChange={(e) =>
                          handleSelectAllJobs(e.target.checked)
                        }
                      />
                    </th>
                    <th>Job List</th>

                    <th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {jobList.map((job) => {
                    const isSelected = selectedJobs.some(
                      (j) => j.action_master_id === job.action_master_id
                    );
                    const amount = job.rate * job.qty;

                    return (
                      <tr
                        key={job.action_master_id}
                        style={{
                          background: isSelected
                            ? "#e3f2fd"
                            : "white",
                          transition: "0.2s",
                        }}
                      >
                        <td className="text-center">
                          <Form.Check
                            checked={isSelected}
                            onChange={() =>
                              handleJobSelect(job)
                            }
                          />
                        </td>

                        <td>{job.action_name}</td>

                        <td className="text-center fw-bold">
                          ₹ {job.amount}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            {/* Selected Total */}
            {selectedJobs.length > 0 && (
              <div
                className="d-flex justify-content-between align-items-center mt-2"
                style={{
                  background: "#e8f5e9",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              >
                <span className="fw-semibold text-success">
                  Selected Total
                </span>
                <span className="fw-bold text-success">
                 ₹ {selectedJobs
  .reduce((sum, j) => sum + Number(j.amount || 0), 0)
  .toFixed(2)}
                </span>
              </div>
            )}
          </>
        )}

        {/* ================= MEMBER LIST ================= */}
        {selectedVendor?.vendor_type_id === 3 &&
          memberList.length > 0 && (
            <>
              <h6 className="fw-bold text-primary mt-4">
                Select Member
              </h6>

              <div
                style={{
                  maxHeight: "180px",
                  overflowY: "auto",
                }}
              >
                <Table bordered hover size="sm">
                  <thead style={{ background: "#edf7fe" }}>
                    <tr>
                      <th className="text-center">
                        <Form.Check
                          checked={selectAllMembers}
                          onChange={(e) =>
                            handleSelectAllMembers(
                              e.target.checked
                            )
                          }
                        />
                      </th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Beneficiary ID</th>
                      <th>SHG</th>
                    </tr>
                  </thead>

                  <tbody>
                    {memberList.map((m) => (
                      <tr key={m.user_id}>
                        <td className="text-center">
                          <Form.Check
                            checked={selectedMembers.includes(
                              m.user_id
                            )}
                            onChange={() =>
                              handleMemberSelect(m.user_id)
                            }
                          />
                        </td>
                        <td>{m.name}</td>
                        <td>{m.mobile}</td>
                        <td>{m.beneficiary_id}</td>
                        <td>{m.shg_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}

        {/* ================= PAYMENT ================= */}
        <Form.Group className="mt-3">
          <Form.Label className="fw-semibold">
            Payment Amount <span className="text-danger">*</span>
          </Form.Label>

          <div className="input-group">
            <span className="input-group-text">₹</span>

            <Form.Control
               type="number"
                value={payAmount}
                onChange={(e) => setPayAmount(e.target.value)}
                placeholder="Enter payment amount"
                disabled
            />
          </div>

          {selectedJobs.length > 0 && (
            <div className="text-muted small mt-1">
              Auto-calculated from selected jobs
            </div>
          )}
        </Form.Group>

        {/* Remarks */}
        <Form.Group className="mt-2">
          <Form.Label className="fw-semibold">
            Remarks
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            value={remarks}
            onChange={(e) =>
              setRemarks(e.target.value)
            }
          />
        </Form.Group>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowPayModal(false)}
    >
      Cancel
    </Button>

    <Button
      style={{
        background: "#2E7D32",
        border: "none",
      }}
      onClick={handlePaymentSubmit}
    >
      Make Payment
    </Button>
  </Modal.Footer>
</Modal>


    </div>
  );
};

export default PaymentList;
